(() => {
  "use strict";

  window.MonelloConfig = Object.freeze({
    debug: true,

    addons: Object.freeze({
      completeSet: Object.freeze({
        variantId: 58595576349017,
        code: "P5995",
        label: "Komplett-Set",
      }),
    }),
  });
})();